<template>
  <div class="adv-registry-filter-form-wrapper custom-wrapper">
    <!--表格查询表单-->
    <div class="filter-wrapper" >
      <el-form
        label-position="right"
        label-width="100px"
        ref="filterForm"
        :model="filterForm">

        <el-form-item label="设备货架数量" prop="goods_length">
          <el-input
            v-model="filterForm.goods_length"
            placeholder="请输入货架数量"
            @keyup.enter.native="onFilterSubmit">
          </el-input>
        </el-form-item>

        <el-form-item label="设备类型" prop="type">
          <el-select v-model="filterForm.type" placeholder="请选择设备类型">
            <el-option label="全部" value=""></el-option>
            <el-option label="扭蛋机" value="gpm"></el-option>
            <el-option label="自动贩卖机" value="vm"></el-option>
            <el-option label="口红机" value="lpk"></el-option>
            <el-option label="脉冲" value="mc"></el-option>
            <el-option label="福袋机" value="fdj"></el-option>
            <el-option label="格子机" value="gzj"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="submit">
        <el-button
          type="danger"
          size="medium"
          @click="onFilterSubmit">查询</el-button>
        <el-button
          size="medium"
          @click="resetFilters">重置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import {
  SET_PAGE,
  SET_FILTERS
} from '@/store/modules/table'
import {
  SET_ADV_REGISTRY_FILTER_FLAG
} from '@/store/modules/factory'

export default {
  name: 'AdvRegistryFilterForm',
  data () {
    return {
      filterForm: {
        goods_length: '',
        type: ''
      }
    }
  },
  computed: {
    ...mapState('factory', [
      'advRegistryFilterFlag'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_FILTERS
    ]),
    ...mapMutations('factory', {
      'setAdvRegistryFilterFlag': SET_ADV_REGISTRY_FILTER_FLAG
    }),

    onFilterSubmit () {
      this.setPage(1)
      this.setFilters(this.filterForm)

      if (this.filterForm.goods_length !== '' && this.filterForm.type !== '') {
        this.setAdvRegistryFilterFlag(true)
      } else {
        this.setAdvRegistryFilterFlag(false)
      }

      this.$emit('filter')
    },
    resetFilters () {
      this.$refs['filterForm'].resetFields()
    }
  }
}
</script>

<style lang="scss" scope>
@import "../../assets/sass/base";

.adv-registry-filter-form-wrapper {

  .filter-wrapper .el-form-item {
    width: 25%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/adv_registry/AdvRegistryFilterForm.vue